import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {UserModel} from '@app/models/user';
import {Repository} from '@app/@core/repositories/repository';
import User = UserModel.User;
import {Voucher} from '@app/models/v3/voucher';

type UserVoucherType = 'Default' | 'Refund' | 'SorryGD';

export interface Country {
    name: string;
    dial_code: string;
    code: string;
}

interface IsExist {
    status: 'EXIST' | 'NOT_EXIST';
}

export interface UserSearchResult {
    id: string;
    fname: string;
    lname: string;
    email: string;
    mobile: string;
    status: string;
    agencyId: number;
    created: Date;
}

@Injectable({
    providedIn: 'root'
})
export class UserRepository extends Repository<User> {

    constructor(http: HttpClient) {
        super(http, 'user');
    }


    setPassword(userId: string, newPassword: string): Observable<void> {
        return this.http.put<any>(`${this.entityUrl}/${userId}/password`, {newPassword});
    }

    search(term: string, fields = ['fname', 'lname', 'email', 'mobile']): Observable<UserSearchResult[]> {
        return this.http.get<any>(`${this.entityUrl}/search`, {params: {term, fields}});
    }

    getUserVouchers(userId: string): Observable<Voucher[]> {
        return this.http.get<Voucher[]>(`${this.entityUrl}/${userId}/vouchers`);
    }

    sendVoucher(userId: string, price: number, voucherType: UserVoucherType, voucherNumber = 1, courseName = ''): Observable<void> {
        const params = {
            price,
            voucherType,
            voucherNumber,
            courseId: courseName
        };
        return this.http.get<any>(`${this.entityUrl}/${userId}/voucher`, {params});
    }

    updateCardInfo(userId: string, cards: UserModel.CardInfo[]): Observable<void> {
        return this.http.put<any>(`${this.entityUrl}/${userId}/cardInfo`, cards);
    }

    // protected covertFromServer(user: any): UserModel.User {
    //     UserRepository.convertDotTimeStampToDate(user, 'userLevel.privilege.start');
    //     UserRepository.convertDotTimeStampToDate(user, 'userLevel.privilege.end');
    //     return user;
    // }

    isEmailNotExist(email: string) {
        const params = {email};
        return this.http.get<IsExist>(`${this.baseURL}/api/account/email/check`, {params})
            .pipe(map(({status}) => status === 'NOT_EXIST'));
    }

    isMobileNotExist(isoCode: string, mobile: string) {
        const params = {isoCode, mobile};
        return this.http.get<IsExist>(`${this.baseURL}/api/account/mobile/check`, {params})
            .pipe(map(({status}) => status === 'NOT_EXIST'));
    }

    fetchCountry(): Observable<Country[]> {
        return this.http.get<Country[]>('assets/countries.json');
    }

    upgradeFamilyLevel(userId: string, level: 'GOLFDIGG'| 'GOLD' | 'BLACK'): Observable<void> {
        return this.http.post<any>(`${this.entityUrl}/${userId}/setLevel`, {level});
    }

    sendSMS(id: string, channel: 'NOTIFY' | 'SMS', message: string, mobile: string): Observable<any> {
        const params = {
            channel,
            message,
            mobile
        };

        return this.http.post<any>(`${this.entityUrl}/${id}/notify`, params);
    }
}

